const enumToText = (role) => {
  const lowerCaseValue = `${role}`.toLowerCase();
  const words = lowerCaseValue.split('_');
  const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalizedWords.join(' ');
};

export default enumToText;
